var GALLERY_MODE = {
  maxImage: 'maxImage',
  shortestEdge: 'shortestEdge',
  fullScreen: 'fullScreen'
};
var JS_CLASSES = {
  newGallery: 'js__gallery_new',
  anchorImage: 'js__gallery-anchor-image',
  image: 'js__gallery-image',
  selectedImageNumber: 'js__gallery-selected-image-number',
  imageDescription: 'js__gallery-image-description',
  imageAnnouncement: 'js__gallery-image-announcement',
  previous: 'js__gallery-previous',
  next: 'js__gallery-next',
  images: 'js__gallery-images',
  imagesContainer: 'js__gallery-images-container',
  copyLinkButton: 'js__gallery-copy-link',
  firstTemporaryContainer: 'js__gallery-temporary-image-container_first',
  lastTemporaryContainer: 'js__gallery-temporary-image-container_last',
  close: ''
};
var DIMENSIONS_TYPE = {
  initial: 'initial',
  real: 'real'
};

export { DIMENSIONS_TYPE, GALLERY_MODE, JS_CLASSES };
//# sourceMappingURL=constants.js.map
